import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Navbar, Nav, NavItem, NavDropdown, MenuItem, OverlayTrigger, Tooltip } from 'react-bootstrap';

import { routeStrings as routes } from 'config/routes';
import { getIsWhitelisted, getIsAuthenticated, getHasLoginError } from 'selectors/auth';
import { getUser } from 'selectors/user';

export const HOMEPAGE_NAV_TYPE = 'homepage-nav';
export const INTERNAL_NAV_TYPE = 'internal-nav';

export function NavigationBar({ isAuthenticated, userInfo, isWhitelisted, historyPush, navType, hasLoginError }) {
  const fixedTop = navType !== HOMEPAGE_NAV_TYPE;
  const staticTop = navType === HOMEPAGE_NAV_TYPE;
  const fluid = navType !== HOMEPAGE_NAV_TYPE;
  const navigate = pathname => () => historyPush(pathname);
  const loginErrorTooltip = (
    <Tooltip id="tooltip" className="login-error-tooltip">
      Sorry, we are having some technical difficulties. Please refresh this page in a few minutes.
    </Tooltip>
  );

  return (
    <Navbar
      inverse={false}
      className={navType}
      fixedTop={fixedTop}
      staticTop={staticTop}
      fluid={fluid}
      collapseOnSelect
    >
      <Navbar.Header>
        <Navbar.Brand>
          <Link to={routes.MAIN} className="navbar-brand">
            <span className="navbar-logo">Spotify</span>
          </Link>
        </Navbar.Brand>
        <Navbar.Toggle />
      </Navbar.Header>
      <Navbar.Collapse>
        <Nav pullRight>
          {isAuthenticated &&
            isWhitelisted &&
            <NavItem title="Spotify Ad Studio Manage Your Ads" onClick={navigate(`/${routes.BROWSE_ADS}`)}>
              Manage Ads
            </NavItem>}

          {(!isWhitelisted || !isAuthenticated) && <NavItem onClick={navigate(routes.WAITLIST)}>Join Waitlist</NavItem>}

          <NavItem title="Spotify Ad Studio FAQs page" onClick={navigate(`/${routes.FAQ}`)}>
            FAQs
          </NavItem>

          <NavItem role="separator" className="divider" />

          {!isAuthenticated &&
            hasLoginError &&
            <OverlayTrigger id="login-error-overlay" placement="bottom" overlay={loginErrorTooltip}>
              <NavItem title="Spotify Ad Studio log in with error" id="navbar-login" disabled className="login-error">
                Log In
              </NavItem>
            </OverlayTrigger>}

          {!isAuthenticated &&
            !hasLoginError &&
            <NavItem title="Spotify Ad Studio log in page" id="navbar-login" onClick={navigate(routes.LOGIN)}>
              Log In
            </NavItem>}

          {isAuthenticated &&
            <NavDropdown
              id="user-dropdown"
              className="ta-user-badge-toggle user-badge-toggle"
              title={
                <div style={{ display: 'inline' }}>
                  {userInfo.imgSrc &&
                    <img alt="User" className="user-img img-circle navbar-user-img" src={userInfo.imgSrc} />}
                  {userInfo.displayName || userInfo.id}
                </div>
              }
            >
              <MenuItem
                title="Spotify Ad Studio account page"
                onClick={navigate(routes.ACCOUNT)}
                className="ta-account"
              >
                Account
              </MenuItem>
              <MenuItem title="Spotify Ad Studio log out" onClick={navigate(routes.LOGOUT)} className="ta-logout">
                Log out
              </MenuItem>
            </NavDropdown>}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

NavigationBar.defaultProps = {
  navType: HOMEPAGE_NAV_TYPE,
};

NavigationBar.propTypes = {
  hasLoginError: PropTypes.bool,
  historyPush: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  isWhitelisted: PropTypes.bool.isRequired,
  userInfo: PropTypes.object,
  navType: PropTypes.oneOf([
    HOMEPAGE_NAV_TYPE,
    INTERNAL_NAV_TYPE,
  ]),
};

function mapStateToProps(state) {
  return {
    isAuthenticated: getIsAuthenticated(state),
    isWhitelisted: getIsWhitelisted(state),
    hasLoginError: getHasLoginError(state),
    userInfo: getUser(state),
  };
}

export default connect(mapStateToProps, {
  historyPush: push,
})(NavigationBar);



// WEBPACK FOOTER //
// ./src/components/NavigationBar.js